export const translations = {
  en: {
    nav_home: "Home", nav_products: "Products", nav_about: "About", nav_contact: "Contact",
    enquire: "Enquire", whatsapp_us: "WhatsApp Us", quick_enquiry: "Quick Enquiry",
    explore_collection: "Explore Collection", view_all: "View all products",
    start_enquiry: "Start an Enquiry", enquire_whatsapp: "Enquire on WhatsApp",
    send_whatsapp: "Send on WhatsApp", send_via_whatsapp: "Send via WhatsApp",
    all_products: "All Products", explore_products: "Explore our products",

    hero_eyebrow: "Premium Makhana • Est. 2024",
    hero_lines: ["Crafted by", "Nature,", "Perfected by us."],
    hero_subtitle: "Mulywan brings you hand-picked jumbo fox nuts and premium daily essentials — a taste of Bihar's finest, packed with purity and pride.",
    badge_fssai: "FSSAI Licensed", badge_udyam: "UDYAM Registered", badge_natural: "100% Natural",
    scroll: "Scroll",

    ribbon_home: ["Premium Makhana", "Luxury Packaging", "Fox Nuts", "Made in Bihar", "Honest Quality"],
    stats: [
      { k: "100%", v: "Natural & Vegetarian" },
      { k: "9G+", v: "Protein per 100g" },
      { k: "6-Sutta", v: "Jumbo Grade" },
      { k: "2024", v: "Proudly Since" },
    ],

    collection_eyebrow: "The Collection",
    collection_t1: "Signature", collection_t2: "selections",
    signature_note: "Tap any product to explore details and enquire on WhatsApp.",

    manifesto_eyebrow: "Our Manifesto",
    manifesto_title: "Three beliefs behind every pack.",
    manifesto: [
      { title: "Rooted in Mithila", body: "Every fox nut is born in the lotus ponds of Bihar's Mithila belt — the world's finest makhana terroir. We source directly from farming families we've known for years." },
      { title: "Purity, Uncompromised", body: "Hand-picked, sun-roasted and grade-sorted. No shortcuts, no fillers. FSSAI-licensed and packed to lock in that signature crunch and freshness." },
      { title: "Strength You Can Trust", body: "From premium snacks to heavy-duty daily essentials, the Mulywan mark is a promise of honest quality that holds up to real life." },
    ],

    cta_eyebrow: "Bulk & Wholesale Welcome",
    cta_t1: "Let's stock your shelves with", cta_t2: "Mulywan.",
    cta_body: "Retailers, distributors and gifting partners — reach out for pricing, samples and custom quantities. A quick chat on WhatsApp is all it takes.",
    brand_by: "A Brand by",

    footer_blurb: "Premium Makhana & everyday essentials, crafted in the heart of Bihar. A promise of purity, strength and honest quality — from our home to yours.",
    footer_explore: "Explore", footer_reach: "Reach Us", footer_rights: "All rights reserved.",

    products_eyebrow: "Shop the range",
    products_t1: "Our", products_t2: "Products",
    products_subtitle: "Premium makhana in every flavour you love, plus dependable everyday essentials. Tap any product to explore details and enquire on WhatsApp.",
    filter_all: "All", filter_makhana: "Makhana", filter_bags: "Garbage Bags",

    detail_highlights: "Highlights", detail_specs: "Specifications",
    detail_also: "You may also", detail_like: "like",

    about_eyebrow: "About Mulywan",
    about_title: ["From the ponds of Bihar,", "to your table."],
    about_p1: "Mulywan is the flagship brand of Cute Global Trade — a proud, home-grown enterprise from Samastipur, Bihar. We exist to celebrate one of India's most extraordinary superfoods, the humble makhana, and to deliver it with the honesty and quality it deserves.",
    about_p2: "What began as a simple belief — that the world deserves Bihar's best — has grown into a promise carried on every pack. Alongside our premium makhana, we craft dependable daily essentials, all under one mark you can trust. Purity, strength and honest value: that is the Mulywan way.",
    ribbon_about: ["Purity", "Tradition", "Trust", "Made in Bihar", "Family First"],
    journey_eyebrow: "Our Journey",
    journey_t1: "A young brand,", journey_t2: "an age-old craft.",
    journey: [
      { year: "The Land", title: "Born in Mithila", body: "Samastipur, Bihar — the beating heart of India's makhana country. This is where our story, and our fox nuts, begin." },
      { year: "2024", title: "Cute Global Trade is founded", body: "Registered on 05 July 2024 as a proprietorship led by Kundan Kumar, with a single mission: take Bihar's finest to every Indian home." },
      { year: "Today", title: "The Mulywan promise", body: "A growing family of premium makhana and everyday essentials — FSSAI-licensed, UDYAM-registered, and made with genuine care." },
    ],
    director_quote: "We don't just sell makhana. We carry the pride of every farmer, every pond and every sunrise over Mithila — packed with care, for your family.",
    director_attr: "Kundan Kumar — Founder & Director, Cute Global Trade",
    cred_eyebrow: "Certified & Compliant",
    cred_title: "Credentials you can trust",
    cred_gst: "GST Number", cred_udyam: "UDYAM Registration", cred_fssai: "FSSAI License", cred_director: "Director",
    reg_office: "Registered Office", registered_on: "Registered on", proprietorship: "Proprietorship",

    contact_eyebrow: "Get in touch",
    contact_title: ["Let's talk", "Mulywan."],
    contact_subtitle: "Questions, bulk orders or partnerships — we're a message away. Fill the form and continue the conversation instantly on WhatsApp.",
    label_primary: "Primary", label_secondary: "Secondary",
    working_hours_label: "Working Hours", working_hours_val: "Mon – Sat · 9:00 AM – 7:00 PM",
    form_name: "Name", form_mobile: "Mobile", form_email: "Email", form_message: "Message",
    ph_name: "Your full name", ph_mobile: "10-digit number", ph_email: "Optional", ph_message: "Tell us what you're looking for…",
    form_footnote_contact: "Your details go straight to our team on WhatsApp.",

    modal_eyebrow: "Product Enquiry",
    modal_subtitle: "Share your details — we'll continue the conversation on WhatsApp with pricing & availability.",
    modal_name: "Your Name", modal_mobile: "Mobile Number",
    modal_ph_name: "e.g. Rahul Kumar", modal_ph_mobile: "10-digit number",
    modal_footnote: "No spam. We only use this to respond to your enquiry.",
    err_name: "Please enter your name", err_mobile: "Enter a valid 10-digit mobile number",
    toast_redirect: "Redirecting you to WhatsApp…", toast_opening: "Opening WhatsApp…", toast_ready: "Your message is ready to send.",

    testimonials_eyebrow: "Loved by families",
    testimonials_t1: "What our",
    testimonials_t2: "customers say",
    testimonials_rating: "Rated 4.9 / 5 by happy customers across India",
    reviews: [
      { name: "Priya Sharma", location: "Patna, Bihar", rating: 5, text: "The Premium Makhana is unbelievably crunchy and fresh — you can tell it's genuinely hand-picked. My whole family is hooked!" },
      { name: "Rahul Verma", location: "New Delhi", rating: 5, text: "Ordered the Peri Peri makhana for our office and it vanished in a day. Bold flavour without the oily guilt. Highly recommend." },
      { name: "Anjali Gupta", location: "Lucknow, UP", rating: 5, text: "Finally a healthy snack my kids actually ask for. The Cheese & Herbs pack is a winner in our home." },
      { name: "Sanjay Kumar", location: "Muzaffarpur, Bihar", rating: 4, text: "Bought the Jumbo Raw 500g pack for my shop. Export-grade quality and the team was super responsive on WhatsApp." },
      { name: "Meena Devi", location: "Samastipur, Bihar", rating: 5, text: "The garbage bags are seriously strong — no leaks, no tearing. Proud that such a premium brand is from our own Bihar." },
      { name: "Arjun Nair", location: "Mumbai", rating: 5, text: "Beautiful packaging, honest quality. The roasted salted makhana is my go-to evening snack now. Will order again." },
    ],

    price_best: "Enquire for best price", price_wholesale: "Enquire for wholesale price",
    cat: { "Makhana": "Makhana", "Garbage Bags": "Garbage Bags" },
    hl: {},
  },

  hi: {
    nav_home: "होम", nav_products: "उत्पाद", nav_about: "हमारे बारे में", nav_contact: "संपर्क",
    enquire: "पूछताछ", whatsapp_us: "WhatsApp करें", quick_enquiry: "त्वरित पूछताछ",
    explore_collection: "संग्रह देखें", view_all: "सभी उत्पाद देखें",
    start_enquiry: "पूछताछ शुरू करें", enquire_whatsapp: "WhatsApp पर पूछें",
    send_whatsapp: "WhatsApp पर भेजें", send_via_whatsapp: "WhatsApp पर भेजें",
    all_products: "सभी उत्पाद", explore_products: "हमारे उत्पाद देखें",

    hero_eyebrow: "प्रीमियम मखाना • स्थापना 2024",
    hero_lines: ["प्रकृति की देन,", "शुद्धता के साथ,", "आप तक।"],
    hero_subtitle: "मुलीवान लाता है हाथ से चुने जम्बो मखाने और प्रीमियम रोज़मर्रा की चीज़ें — बिहार की बेहतरीन सौगात, शुद्धता और गर्व के साथ।",
    badge_fssai: "FSSAI लाइसेंस प्राप्त", badge_udyam: "UDYAM पंजीकृत", badge_natural: "100% प्राकृतिक",
    scroll: "स्क्रॉल",

    ribbon_home: ["प्रीमियम मखाना", "शानदार पैकेजिंग", "फॉक्स नट्स", "बिहार में निर्मित", "ईमानदार गुणवत्ता"],
    stats: [
      { k: "100%", v: "प्राकृतिक व शाकाहारी" },
      { k: "9G+", v: "प्रोटीन प्रति 100 ग्राम" },
      { k: "6-सुत्ता", v: "जम्बो ग्रेड" },
      { k: "2024", v: "गर्व से, तब से" },
    ],

    collection_eyebrow: "हमारा संग्रह",
    collection_t1: "बेहतरीन", collection_t2: "चयन",
    signature_note: "किसी भी उत्पाद पर टैप करें और WhatsApp पर पूछताछ करें।",

    manifesto_eyebrow: "हमारा संकल्प",
    manifesto_title: "हर पैक के पीछे तीन विश्वास।",
    manifesto: [
      { title: "मिथिला की जड़ें", body: "हर मखाना बिहार के मिथिला अंचल के कमल तालाबों में पलता है — दुनिया का सबसे बेहतरीन मखाना क्षेत्र। हम सीधे किसान परिवारों से खरीदते हैं जिन्हें हम वर्षों से जानते हैं।" },
      { title: "बेमिसाल शुद्धता", body: "हाथ से चुना, धूप में भुना और ग्रेड के अनुसार छाँटा। कोई शॉर्टकट नहीं, कोई मिलावट नहीं। FSSAI लाइसेंस प्राप्त और ताज़गी व कुरकुरापन बनाए रखने के लिए पैक किया गया।" },
      { title: "भरोसेमंद मज़बूती", body: "प्रीमियम स्नैक्स से लेकर मज़बूत रोज़मर्रा की चीज़ों तक, मुलीवान का नाम ईमानदार गुणवत्ता का वादा है जो असल ज़िंदगी में खरा उतरता है।" },
    ],

    cta_eyebrow: "थोक व होलसेल का स्वागत",
    cta_t1: "आइए आपकी दुकान सजाएँ", cta_t2: "मुलीवान से।",
    cta_body: "रिटेलर, वितरक और गिफ्टिंग पार्टनर — दाम, सैंपल और कस्टम मात्रा के लिए संपर्क करें। WhatsApp पर एक छोटी बातचीत ही काफी है।",
    brand_by: "एक ब्रांड —",

    footer_blurb: "प्रीमियम मखाना और रोज़मर्रा की ज़रूरी चीज़ें, बिहार के दिल से। शुद्धता, मज़बूती और ईमानदार गुणवत्ता का वादा — हमारे घर से आपके घर तक।",
    footer_explore: "एक्सप्लोर", footer_reach: "संपर्क करें", footer_rights: "सर्वाधिकार सुरक्षित।",

    products_eyebrow: "पूरी रेंज देखें",
    products_t1: "हमारे", products_t2: "उत्पाद",
    products_subtitle: "आपके पसंदीदा हर स्वाद में प्रीमियम मखाना, साथ ही भरोसेमंद रोज़मर्रा की चीज़ें। किसी भी उत्पाद पर टैप करें और WhatsApp पर पूछताछ करें।",
    filter_all: "सभी", filter_makhana: "मखाना", filter_bags: "गार्बेज बैग",

    detail_highlights: "विशेषताएँ", detail_specs: "विवरण",
    detail_also: "आपको यह भी", detail_like: "पसंद आ सकता है",

    about_eyebrow: "मुलीवान के बारे में",
    about_title: ["बिहार के तालाबों से,", "आपकी थाली तक।"],
    about_p1: "मुलीवान, क्यूट ग्लोबल ट्रेड का प्रमुख ब्रांड है — समस्तीपुर, बिहार का एक गर्वित, स्वदेशी उद्यम। हम भारत के सबसे अनोखे सुपरफूड, साधारण मखाने का उत्सव मनाने और उसे उस ईमानदारी व गुणवत्ता के साथ पहुँचाने के लिए हैं जिसका वह हक़दार है।",
    about_p2: "जो एक साधारण विश्वास से शुरू हुआ — कि दुनिया बिहार की बेहतरीन चीज़ों की हक़दार है — वह आज हर पैक पर एक वादा बन गया है। प्रीमियम मखाने के साथ-साथ हम भरोसेमंद रोज़मर्रा की चीज़ें भी बनाते हैं, सब एक भरोसेमंद नाम के तहत। शुद्धता, मज़बूती और ईमानदार मूल्य: यही है मुलीवान का तरीका।",
    ribbon_about: ["शुद्धता", "परंपरा", "भरोसा", "बिहार में निर्मित", "परिवार पहले"],
    journey_eyebrow: "हमारी यात्रा",
    journey_t1: "नया ब्रांड,", journey_t2: "सदियों पुरानी कला।",
    journey: [
      { year: "यह धरती", title: "मिथिला में जन्म", body: "समस्तीपुर, बिहार — भारत के मखाना क्षेत्र का धड़कता दिल। यहीं से हमारी कहानी और हमारे मखाने शुरू होते हैं।" },
      { year: "2024", title: "क्यूट ग्लोबल ट्रेड की स्थापना", body: "05 जुलाई 2024 को कुंदन कुमार के नेतृत्व में एक प्रोप्राइटरशिप के रूप में पंजीकृत, एक ही मिशन के साथ: बिहार की बेहतरीन चीज़ें हर भारतीय घर तक पहुँचाना।" },
      { year: "आज", title: "मुलीवान का वादा", body: "प्रीमियम मखाना और रोज़मर्रा की चीज़ों का बढ़ता परिवार — FSSAI लाइसेंस प्राप्त, UDYAM पंजीकृत, और सच्ची देखभाल से बना।" },
    ],
    director_quote: "हम सिर्फ़ मखाना नहीं बेचते। हम हर किसान, हर तालाब और मिथिला के हर सूर्योदय का गर्व लेकर चलते हैं — आपके परिवार के लिए, देखभाल के साथ पैक।",
    director_attr: "कुंदन कुमार — संस्थापक व निदेशक, क्यूट ग्लोबल ट्रेड",
    cred_eyebrow: "प्रमाणित व अनुपालित",
    cred_title: "भरोसेमंद प्रमाण",
    cred_gst: "GST नंबर", cred_udyam: "UDYAM पंजीकरण", cred_fssai: "FSSAI लाइसेंस", cred_director: "निदेशक",
    reg_office: "पंजीकृत कार्यालय", registered_on: "पंजीकृत", proprietorship: "प्रोप्राइटरशिप",

    contact_eyebrow: "संपर्क में रहें",
    contact_title: ["बात करें", "मुलीवान से।"],
    contact_subtitle: "सवाल, थोक ऑर्डर या साझेदारी — हम बस एक संदेश दूर हैं। फ़ॉर्म भरें और WhatsApp पर तुरंत बातचीत जारी रखें।",
    label_primary: "मुख्य", label_secondary: "द्वितीयक",
    working_hours_label: "कार्य समय", working_hours_val: "सोम – शनि · सुबह 9 – शाम 7",
    form_name: "नाम", form_mobile: "मोबाइल", form_email: "ईमेल", form_message: "संदेश",
    ph_name: "आपका पूरा नाम", ph_mobile: "10 अंकों का नंबर", ph_email: "वैकल्पिक", ph_message: "बताइए आप क्या ढूँढ रहे हैं…",
    form_footnote_contact: "आपकी जानकारी सीधे हमारी टीम को WhatsApp पर पहुँचेगी।",

    modal_eyebrow: "उत्पाद पूछताछ",
    modal_subtitle: "अपनी जानकारी साझा करें — हम दाम व उपलब्धता के साथ WhatsApp पर बातचीत जारी रखेंगे।",
    modal_name: "आपका नाम", modal_mobile: "मोबाइल नंबर",
    modal_ph_name: "जैसे राहुल कुमार", modal_ph_mobile: "10 अंकों का नंबर",
    modal_footnote: "कोई स्पैम नहीं। हम इसका उपयोग केवल आपकी पूछताछ का जवाब देने के लिए करेंगे।",
    err_name: "कृपया अपना नाम लिखें", err_mobile: "मान्य 10 अंकों का मोबाइल नंबर लिखें",
    toast_redirect: "WhatsApp पर भेजा जा रहा है…", toast_opening: "WhatsApp खोला जा रहा है…", toast_ready: "आपका संदेश भेजने के लिए तैयार है।",

    testimonials_eyebrow: "परिवारों का भरोसा",
    testimonials_t1: "हमारे ग्राहक",
    testimonials_t2: "क्या कहते हैं",
    testimonials_rating: "पूरे भारत के खुश ग्राहकों द्वारा 4.9 / 5 रेटिंग",
    reviews: [
      { name: "प्रिया शर्मा", location: "पटना, बिहार", rating: 5, text: "प्रीमियम मखाना इतना कुरकुरा और ताज़ा है कि साफ़ पता चलता है यह सचमुच हाथ से चुना गया है। मेरा पूरा परिवार इसका दीवाना है!" },
      { name: "राहुल वर्मा", location: "नई दिल्ली", rating: 5, text: "ऑफिस के लिए पेरी पेरी मखाना मँगाया और एक ही दिन में खत्म। तेज़ स्वाद, वो भी बिना तेल की बेफिक्री के। ज़रूर लें।" },
      { name: "अंजली गुप्ता", location: "लखनऊ, यूपी", rating: 5, text: "आखिरकार एक सेहतमंद स्नैक जो मेरे बच्चे खुद माँगते हैं। चीज़ एंड हर्ब्स पैक हमारे घर का पसंदीदा है।" },
      { name: "संजय कुमार", location: "मुज़फ़्फ़रपुर, बिहार", rating: 4, text: "अपनी दुकान के लिए जम्बो रॉ 500 ग्राम पैक लिया। एक्सपोर्ट क्वालिटी और टीम ने WhatsApp पर बहुत जल्दी जवाब दिया।" },
      { name: "मीना देवी", location: "समस्तीपुर, बिहार", rating: 5, text: "गार्बेज बैग वाकई बहुत मज़बूत हैं — न लीक, न फटना। गर्व है कि इतना प्रीमियम ब्रांड हमारे अपने बिहार से है।" },
      { name: "अर्जुन नायर", location: "मुंबई", rating: 5, text: "खूबसूरत पैकेजिंग, ईमानदार गुणवत्ता। रोस्टेड साल्टेड मखाना अब मेरा शाम का पसंदीदा स्नैक है। फिर से ऑर्डर करूँगा।" },
    ],

    price_best: "बेहतरीन दाम के लिए पूछें", price_wholesale: "थोक दाम के लिए पूछें",
    cat: { "Makhana": "मखाना", "Garbage Bags": "गार्बेज बैग" },
    hl: {
      "High Protein": "उच्च प्रोटीन", "Low Fat": "कम वसा", "Rich in Antioxidants": "एंटीऑक्सीडेंट से भरपूर",
      "Gluten Free": "ग्लूटेन फ्री", "Ready to Eat": "खाने के लिए तैयार", "Himalayan Salt": "हिमालयन नमक",
      "Zero Trans Fat": "ज़ीरो ट्रांस फैट", "Roasted in Ghee": "घी में भुना", "Bold Flavour": "तेज़ स्वाद",
      "Baked Not Fried": "तला नहीं, बेक किया", "Snack Anytime": "कभी भी स्नैक", "Kids Favourite": "बच्चों का पसंदीदा",
      "Rich in Calcium": "कैल्शियम से भरपूर", "Real Cheese": "असली चीज़", "Value Pack": "वैल्यू पैक",
      "Cook Your Way": "अपने तरीके से पकाएँ", "Export Quality": "एक्सपोर्ट क्वालिटी", "Bulk Supply": "थोक आपूर्ति",
      "Leak Proof": "लीक प्रूफ", "Extra Strong": "अतिरिक्त मज़बूत", "Easy Tear-off Roll": "आसान टियर-ऑफ रोल",
      "Odour Lock": "गंध रोकने वाला", "Heavy Duty": "हैवी ड्यूटी", "High Load Capacity": "अधिक भार क्षमता",
      "Puncture Resistant": "पंक्चर रोधी", "Oxo-Biodegradable": "ऑक्सो-बायोडिग्रेडेबल", "Eco Friendly": "पर्यावरण अनुकूल",
      "Certified": "प्रमाणित",
    },
  },
};
